<!-- tablesearchmiscellaneousreimbursement.vue -->

<template>
   <Tables ref="tableGrids"
            :columns= coluna
            :showSearch="false"
            :showPrint="false"
            :newHeaderStatus="true"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
            <tr v-for="obj in dataFucionario" :key="obj.id" :class="{'being-fired': obj.emProcessoDemissao, 'em-encerramento': obj.emCancelamentoDiversos && !obj.emProcessoDemissao}">
               <TableColumn  v-if="dataFucionario.map(e => e.statusDespesa === 2 && e.loteid !== null) && hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :IsReturnDirectory="obj.loteid !== null && obj.statusDespesa == 2"/>
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false" v-on:Edit="onSelect(obj)" :status="1" :value="obj.colaborador"/>
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.tecnico != null ? obj.tecnico: 'N/D'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.coordenador != null ? obj.coordenador: 'N/D'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.cargo != null ? obj.cargo: 'N/D'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.obra != null ?  obj.obra : 'N/D'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :value="obj.lote"/>
               <!-- <TableColumn :IsTextYellow="obj.statusDespesa != 2 && obj.statusDespesa != 3 && obj.statusDespesa != 9" :IsTextOrange="obj.statusDespesa == 9" :IsTextBlue="obj.statusDespesa == 3 ? true : false"   :IsTextGreen="obj.statusDespesa == 2" v-on:Edit="onSelect(obj)" :status="1" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :value="obj.statusDespesa != null ?  obj.statusDespesa == 2 ? 'AG. APROVAÇÃO CONTROLADORIA' : obj.statusDespesa == 3 ? 'AG APROVAÇÃO DIRETORIA' : obj.statusDespesa == 9 ? 'AG APROVAÇÃO TÉCNICO' : 'AG. APROVAÇÃO COORDENADOR' :  'N/D'" /> -->
               <TableColumn :IsTextYellow="obj.statusDespesa != 2 && obj.statusDespesa != 3 && obj.statusDespesa != 9" :IsTextOrange="obj.statusDespesa == 9" :IsTextBlue="obj.statusDespesa == 3 ? true : false"   :IsTextGreen="obj.statusDespesa == 2" v-on:Edit="onSelect(obj)" :status="1" :value="obj.statusDespesa != null ?  obj.statusDespesa == 2 ? 'AG. APROVAÇÃO CONTROLADORIA' : obj.statusDespesa == 3 ? 'AG APROVAÇÃO DIRETORIA' : obj.statusDespesa == 9 ? 'AG APROVAÇÃO TÉCNICO' : 'AG. APROVAÇÃO COORDENADOR' :  'N/D'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(data)" :status="1"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :value="obj.primeiroAdiantamento == false || obj.primeiroAdiantamento == null? 'NÃO' : 'SIM'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(data)" :status="1"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :value="obj.saldoInicial == false || obj.saldoInicial == null? 'NÃO' : 'SIM'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(data)" :status="1"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :value="obj.tipoReforco == false || obj.tipoReforco == null? 'NÃO' : 'SIM'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.dataAcaoFormatada != null ? obj.dataAcaoFormatada : 'N/D'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="formatMoney(obj.adiantamentoDescricao)" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.emProcessoDemissao ? obj.saldo < 0 ? 'Valor à Pagar ' + formatMoney(Math.abs(obj.saldo)) : 'Valor à Descontar ' + formatMoney(obj.saldo) : formatMoney(obj.tipoReforco === true ? obj.adiantamentoDescricao : obj.saldo)" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.totalDespesa + 'qnt.'" />
               <TableColumn :IsText="!obj.dataDemissao" :IsTextLocked="obj.dataDemissao != null ? true : false"  v-on:Edit="onSelect(obj)" :status="1" :value="formatMoney(obj.valorTotal)" />

            </tr>
            <template #ButtonsAprova>
               <div class="buttons-table-action" v-if="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
                  <button class="btn-generate-lote" @click="generatelote"><i class="fas fa-file-excel mr-1"/>GERAR LOTE</button>
               </div>
            </template>
   </Tables>
</template>

<script>
import tablesearchmiscellaneousreimbursement from './tablesearchmiscellaneousreimbursement'
export default tablesearchmiscellaneousreimbursement
</script>

<style scoped>
.buttons-table-action{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: right;
  align-items: center;
}

.btn-generate-lote {
   height: 2rem;
   padding: 0 1rem;
   background: #008144;
   color: white;
   border-radius: 8px;
   border: none;
   font-weight: bold;
}
.btn-generate-lote:hover{
   background: #024d2a;
}
/* Tarjas da grid (ZPG-15, tons pedidos em 2026-09-25): desligamento vermelho claro, encerramento de
   Diversos amarelo claro. Fundo claro pede texto escuro. */
tr.being-fired {
   background-color: #ff7081;
}
tr.being-fired >>> a {
   color: #212529;
   font-weight: bold;
}
tr.being-fired:hover >>> a {
   color: #7a0d1c;
   font-weight: bold;
}
tr.em-encerramento {
   background-color: #ffea99;
}
tr.em-encerramento >>> a {
   color: #212529;
   font-weight: bold;
}
tr.em-encerramento:hover >>> a {
   color: #7a5c00;
   font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tablesearchmiscellaneousreimbursement/tablesearchmiscellaneousreimbursement.vue